<script setup lang="ts" generic="T extends { id: string; name: string }">
import { NavArrowDown } from "@iconoir/vue";
import {
  ComboboxAnchor,
  ComboboxContent,
  ComboboxEmpty,
  ComboboxInput,
  ComboboxItem,
  ComboboxPortal,
  ComboboxRoot,
  ComboboxTrigger,
  ComboboxViewport,
} from "reka-ui";

const {
  items,
  searchLabel = "Einträge suchen...",
  emptySearchResultLabel = "Keinen Eintrag gefunden",
} = defineProps<{
  items: Array<T>;
  searchLabel?: string;
  emptySearchResultLabel?: string;
}>();

defineEmits<{
  select: [T];
}>();
</script>

<template>
  <ComboboxRoot>
    <ComboboxAnchor class="combobox-command--anchor">
      <ComboboxInput as-child
        ><input :placeholder="searchLabel"
      /></ComboboxInput>
      <ComboboxTrigger class="button button--tertiary"
        ><NavArrowDown
      /></ComboboxTrigger>
    </ComboboxAnchor>
    <ComboboxPortal>
      <ComboboxContent
        position="popper"
        side="bottom"
        align="start"
        class="combobox-command--content"
        :side-offset="4"
      >
        <ComboboxViewport>
          <ComboboxEmpty class="combobox-command--empty">
            {{ emptySearchResultLabel }}
          </ComboboxEmpty>
          <ComboboxItem
            v-for="item in items"
            :key="item.id"
            :value="item"
            class="combobox-command--item"
            @select.prevent="$emit('select', item)"
          >
            {{ item.name }}
          </ComboboxItem>
        </ComboboxViewport>
      </ComboboxContent>
    </ComboboxPortal>
  </ComboboxRoot>
</template>

<style scoped>
.combobox-command--anchor {
  display: flex;
  justify-content: space-between;
  width: 100%;
  border: none;
  color: var(--text-color-input);
  background-color: var(--bg-color-input);
  border-radius: var(--border-radius-input);
}

:deep(.combobox-command--content) {
  width: var(--reka-combobox-trigger-width);
  max-height: var(--reka-combobox-content-available-height);
  padding: var(--padding-input) 0;
  border-radius: var(--border-radius-input);
  color: var(--text-color-input);
  background-color: var(--bg-color-input);
  box-shadow: var(--shadow);
  overflow-y: auto;
}

.combobox-command--item,
.combobox-command--empty {
  padding: var(--spacing-xs);

  &[data-highlighted] {
    background-color: var(--bg-color-combobox-item-highlighted);
  }
}
</style>
